import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import { useNotificationsStore } from "../stores/notificationsStore";
import { ConnectionStatusDot } from "./ConnectionStatusDot";
import { NotificationsPanel } from "./NotificationsPanel";

export function NotificationsBell() {
  const unread = useNotificationsStore((s) => s.unreadCount);
  const navigate = useNavigate();

  return (
    <PopoverPrimitive.Root>
      <PopoverPrimitive.Trigger asChild>
        <button
          type="button"
          className="relative inline-flex h-7 w-7 items-center justify-center rounded-lg border border-border text-ink-muted hover:border-ink/30 hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-400"
          aria-label={
            unread > 0 ? `Notificações: ${unread} não lida(s)` : "Notificações"
          }
        >
          <Bell size={18} />
          {unread > 0 && (
            <span
              aria-hidden
              className="absolute -right-1 -top-1 inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-danger px-1 text-[10px] font-bold text-white"
            >
              {unread > 99 ? "99+" : unread}
            </span>
          )}
          <ConnectionStatusDot className="absolute -bottom-0.5 -right-0.5" />
        </button>
      </PopoverPrimitive.Trigger>
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          align="end"
          sideOffset={8}
          className="z-50 w-[360px] max-w-[calc(100vw-1.5rem)] rounded-2xl border border-border bg-white shadow-card data-[state=open]:animate-fade-in"
        >
          <NotificationsPanel onSeeAll={() => navigate("/notifications")} />
        </PopoverPrimitive.Content>
      </PopoverPrimitive.Portal>
    </PopoverPrimitive.Root>
  );
}
